import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router';
import moment from 'moment';

import BusinessApi from 'apis/Business';
import CancelSubscription from 'components/Modal/subscription/cancelSubscription';
import ConfirmCancelSubscription from 'components/Modal/subscription/confirmCancelSubscription';
import ManageSubscriptionModal from 'components/Modal/subscription/manageSubscription';
import Toaster from 'components/Toaster';
import {
  getBusinessId,
  setPlanSubscriptionStatus,
} from 'constants/localStorageManager';

import { ROUTES, insertBusinessIdtoUrl } from '../../constants/Routes';

const MODAL_NAMES = {
  MANAGE: 'manageSubscription',
  CANCEL: 'cancelSubscription',
  CONFIRM: 'confirmCancelSubscription',
};

class ManageSubscription extends Component {
  constructor() {
    super();
    this.state = {
      activeModal: '',
      password: '',
    };
  }

  toggleManageSubscription = () => {
    this.toggleModal(MODAL_NAMES.MANAGE);
  };

  toggleCancelSubscription = () => {
    this.toggleModal(MODAL_NAMES.CANCEL);
  };

  toggleConfirmCancellation = () => {
    this.toggleModal(MODAL_NAMES.CONFIRM);
  };

  toggleModal = modalName => {
    const { activeModal } = this.state;
    const isActive = activeModal === modalName;
    if (isActive) return this.closeModal();
    return this.setState({
      activeModal: modalName,
    });
  };

  closeModal = () => {
    this.setState({ activeModal: '' });
  };

  cancelSubscription = () => {
    const { fetchUserDetails, plan_subscription, history } = this.props;
    const { password } = this.state;
    const userPassword = password || '';
    const cancelData = {
      business: {
        plan_subscription_attributes: {
          ...plan_subscription,
          status: 'pending_cancellation',
          cancellation_scheduled_on: moment(),
        },
      },
    };

    BusinessApi.update(getBusinessId(), cancelData, userPassword)
      .then(({ data }) => {
        const { plan_subscription } = data;
        setPlanSubscriptionStatus(plan_subscription);
        this.toggleConfirmCancellation();
        this.setState({ password: null });
        Toaster.getSuccessToaster(
          'check-circle',
          'Plan cancelation request successfull'
        );
        fetchUserDetails();
        history.replace('/');
        history.push(
          insertBusinessIdtoUrl(ROUTES.BUSINESS_USER_DETAIL, getBusinessId())
        );
      })
      .catch(({ response }) => {
        const { error } = response.data;
        Toaster.getErrorToaster('exclamation-triangle', error || 'Error');
      });
  };

  handleChange = e => {
    const { value } = e.target;
    this.setState({ password: value });
  };

  render() {
    const { children, plan_status } = this.props;
    const { password, activeModal } = this.state;

    return (
      <div className="card p-3 text-bold mb-4">
        <ManageSubscriptionModal
          isVisible={activeModal === MODAL_NAMES.MANAGE}
          plan_status={plan_status}
          toggleModal={this.toggleManageSubscription}
          toggleCancelSubscription={this.toggleCancelSubscription}
        />
        <CancelSubscription
          isVisible={activeModal === MODAL_NAMES.CANCEL}
          toggleModal={this.toggleCancelSubscription}
          toggleConfirmCancellation={this.toggleConfirmCancellation}
        />
        <ConfirmCancelSubscription
          isVisible={activeModal === MODAL_NAMES.CONFIRM}
          toggleModal={this.toggleConfirmCancellation}
          password={password}
          handleChange={this.handleChange}
          cancelSubscription={this.cancelSubscription}
        />
        <div
          role="presentation"
          className="cursor-pointer"
          onClick={this.toggleManageSubscription}
        >
          {children}
        </div>
      </div>
    );
  }
}

ManageSubscription.propTypes = {
  fetchUserDetails: PropTypes.func.isRequired,
};

export default withRouter(ManageSubscription);



// WEBPACK FOOTER //
// ./src/components/subscription/manageSubscription.js